<template>
  <div class="container-fluid d-flex align-items-center justify-content-center min-vh-100 flex-column">
    <div class="card mt-1 p-5 text-center w-100" :class="{ 'card-step4': step === 4 }"
      style="max-width: 700px; margin-top: -15vh; display: flex; flex-direction: column; justify-content: center; align-items: center;">
      <!-- Etapa 1 -->
      <div v-if="step === 1">
        <h2 class="mb-4" style="margin-top: -10vh;">Olá, você é cooperado?</h2>
        <div class="d-flex flex-column align-items-center">
          <button class="btn btn-light custom-btn mb-3" @click="setCooperado(true)">SIM</button>
          <button class="btn btn-light custom-btn" @click="setCooperado(false)">NÃO</button>
        </div>
      </div>

      <!-- Etapa 2 -->
      <div v-else-if="step === 2">
        <h2 class="mb-4" style="margin-top: -10vh">{{ isCooperado ? 'Digite seu CPF/CNPJ' : 'Digite seu Nome' }}</h2>
        <input type="text" class="form-control input-lg mb-4" v-model="userInput"
          :placeholder="isCooperado ? 'CPF/CNPJ' : 'Nome'">
        <button class="btn btn-light custom-btn mb-3" @click="nextStep()" :disabled="!userInput">Continuar</button>
      </div>

      <!-- Etapa 3 -->
      <div v-else-if="step === 3">
        <h2 class="mb-4" style="margin-top: -10vh">Qual tipo de atendimento se aplica a você?</h2>
        <div class="d-flex flex-column align-items-center">
          <button class="btn btn-light custom-btn mb-3"
            @click="selectTipoAtendimento('PREFERENCIAL')">Preferencial</button>
          <button class="btn btn-light custom-btn" @click="selectTipoAtendimento('GERAL')">Geral</button>
        </div>
      </div>

      <!-- Etapa 4 -->
      <div v-else-if="step === 4" class="etapa4-container">
        <h2>Em que posso ajudar?</h2>
        <div class="step4">
          <div v-for="categoria in categories" :key="categoria.id" class="button-wrapper">
            <button class="btn btn-light custom-btn button-step4" @click="selectCategory(categoria.nome)">
              {{ categoria.nome }}
            </button>
          </div>
        </div>
      </div>

      <!-- Etapa 5 -->
      <div v-else-if="step === 5">
        <h2 class="mb-4" style="margin-top: -10vh">Escolha uma subcategoria</h2>
        <div v-for="subcategoria in selectedCategory.subcategoria" :key="subcategoria.id"
          class="mb-3 d-flex justify-content-center">
          <button class="btn btn-light custom-btn" @click="selectSubcategory(subcategoria.nome)">
            {{ subcategoria.nome }}
          </button>
        </div>
      </div>

      <!-- Etapa Final -->
      <div v-else-if="step === 6">
        <h2 class="mb-4" style="margin-top: -10vh">Senha retirada com sucesso!</h2>
        <h3 class="mb-4">Sua senha é: <strong>{{ password }}</strong></h3>
        <p class="lead">Acompanhe a sua senha no painel de senhas! Obrigado.</p>
      </div>
    </div>

    <!-- Botões de Navegação-->
    <div class="navigation-buttons w-100 text-center d-flex justify-content-center">
      <button v-if="step > 1" class="btn btn-secondary custom-btn mx-2" @click="previousStep">Voltar</button>
      <button v-if="step > 1 && step !== 6" class="btn btn-danger custom-btn mx-2" @click="confirmCancel">Cancelar</button>
      <button v-if="step === 6" class="btn btn-info custom-btn mx-2" @click="voltarParaInicio">Finalizar</button>
    </div>

    <!-- Modal de Confirmação -->
    <b-modal centered v-model="showConfirmModal" title="Confirmação" hide-footer>
      <div class="text-center">
        <h4 class="mb-3">Deseja realmente finalizar o atendimento?</h4>
        <div class="d-flex justify-content-center">
          <button class="btn btn-secondary custom-btn mx-2" @click="showConfirmModal = false">Não</button>
          <button class="btn btn-danger custom-btn mx-2" @click="resetProcess">Sim</button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import FilaAtendimentoRepository from '@/shared/http/repositories/nxSenhas/fila.js'
import UserRepository from '@/shared/http/repositories/nxSenhas/usuario.js'
import PersonRepository from '@/shared/http/repositories/configurations/person.js'
import decodeJwt from '@/shared/utils/decodeJwt'
import SockJS from 'sockjs-client'
import Stomp from 'stompjs'

export default {
  data () {
    return {
      step: 1,
      userInput: '',
      category: '',
      categoriaSelecionada: false,
      selectedCategory: null,
      selectedSubcategory: null,
      subcategoriaSelecionada: false,
      selectedService: '',
      password: '',
      showConfirmModal: false,
      isCooperado: false,
      decodedUser: {},
      categories: [],
      atendentePrincipal: null,
      inactivityTimer: null,
      preferentialSequence: 0,
      generalSequence: 0,
      idPa: null
    }
  },
  created () {
    this.connectWebSocket()
    const decoded = decodeJwt()
    if (decoded) {
      this.userId = decoded.userId || decoded.id || null
      if (this.userId) {
        UserRepository.GetById(this.userId).then(response => {
          this.atendente = response.data

          const categorias = response.data.mesas.flatMap(mesa => mesa.categorias || [])
          const categoriasUnicas = Array.from(new Map(categorias.map(cat => [cat.id, cat])).values())
          const idPa = response.data.pa ? response.data.pa.id : null

          this.idPa = idPa

          this.categories = categoriasUnicas

          const mesaComAtendente = response.data.mesas.find(mesa => mesa.atendentePrincipal)
          if (mesaComAtendente) {
            this.atendentePrincipal = mesaComAtendente.atendentePrincipal
          }
        })
      }
    }
  },
  methods: {
    setCooperado (isCooperado) {
      this.isCooperado = isCooperado
      this.step = 2
      this.resetInactivityTimer()

      if (isCooperado) {
        this.$watch('userInput', async (newValue) => {
          if (newValue && this.isCooperado) {
            try {
              const response = await PersonRepository.GetByDocument(newValue)
              if (response.data.content) {
                const cooperado = response.data.content[0]
                this.cooperadoId = cooperado.id
                this.nomeCooperado = cooperado.nome || ''
              } else {
                console.warn('Nenhum cooperado encontrado com o documento fornecido.')
                this.cooperadoId = null
              }
            } catch (error) {
              console.error('Erro ao buscar cooperado:', error)
              this.cooperadoId = null
            }
          }
        })
      }
    },
    nextStep () {
      this.step++
      this.resetInactivityTimer()
    },
    previousStep () {
      if (this.step > 1) this.step--
      this.resetInactivityTimer()
    },
    selectTipoAtendimento (tipo) {
      this.selectedService = tipo
      this.step++
      this.resetInactivityTimer()
    },
    selectCategory (category) {
      if (this.categoriaSelecionada) return
      this.categoriaSelecionada = true

      this.selectedCategory = this.categories.find(cat => cat.nome === category)
      this.category = category

      if (this.selectedCategory.subcategoria && this.selectedCategory.subcategoria.length > 0) {
        this.step = 5
      } else {
        if (this.isCooperado && !this.nomeCooperado) {
          alert('Por favor, aguarde a validação do CPF/CNPJ ou verifique se o documento está correto.')
          return
        }
        this.generatePassword()
        this.createFilaAtendimento()
      }
      this.resetInactivityTimer()
    },
    selectSubcategory (subcategory) {
      if (this.subcategoriaSelecionada) return
      this.subcategoriaSelecionada = true

      this.selectedSubcategory = subcategory
      this.generatePassword()
      this.createFilaAtendimento()
    },
    generatePassword () {
      if (this.isCooperado) {
        const primeiroNome = this.nomeCooperado.trim().split(' ')[0].toUpperCase()
        this.password = `${primeiroNome}-${this.selectedService === 'PREFERENCIAL' ? 'P' : 'G'}`
      } else {
        if (this.userInput) {
          this.password = `${this.userInput.toUpperCase()}-${this.selectedService === 'PREFERENCIAL' ? 'P' : 'G'}`
        } else {
          const sequence = this.getNextSequence()
          this.password = `${this.selectedService === 'PREFERENCIAL' ? 'P' : 'G'}${sequence}`
        }
      }
    },
    getNextSequence () {
      const currentSequence = this.selectedService === 'PREFERENCIAL' ? this.preferentialSequence : this.generalSequence
      const nextSequence = currentSequence + 1

      if (this.selectedService === 'PREFERENCIAL') {
        this.preferentialSequence = nextSequence
      } else {
        this.generalSequence = nextSequence
      }

      return nextSequence.toString().padStart(3, '0')
    },
    async createFilaAtendimento () {
      try {
        // 1. Filtra mesas que possuem a categoria selecionada
        const mesasDisponiveis = (this.atendente && this.atendente.mesas)
          ? this.atendente.mesas.filter(mesa =>
            (mesa.categorias || []).some(cat => cat.id === this.selectedCategory.id)
          )
          : []

        // 2. Se não houver mesa disponível, usa a primeira (fallback)
        let mesaEscolhida = null
        if (mesasDisponiveis.length > 0) {
          // 3. Round-robin usando localStorage
          const key = `ultimaMesa_${this.userId}_${this.selectedCategory.id}`
          let lastIndex = parseInt(localStorage.getItem(key) || '0', 10)
          if (lastIndex >= mesasDisponiveis.length) lastIndex = 0
          mesaEscolhida = mesasDisponiveis[lastIndex]
          // Atualiza para próxima rodada
          localStorage.setItem(key, ((lastIndex + 1) % mesasDisponiveis.length).toString())
        } else if (this.atendente && this.atendente.mesas && this.atendente.mesas.length > 0) {
          mesaEscolhida = this.atendente.mesas[0]
        }

        const payload = {
          senhaAtendimento: this.password,
          nome: !this.isCooperado ? this.userInput : '',
          categoriaAtendimento: this.selectedCategory ? this.selectedCategory.nome : null,
          categoriaId: this.selectedCategory && this.selectedCategory.id ? this.selectedCategory.id : null,
          status: 'AGUARDANDO',
          tipoAtendimento: this.selectedService,
          usuarioTotemId: this.userId,
          dataCriacao: new Date(),
          mesaFilaId: mesaEscolhida ? mesaEscolhida.id : null,
          idPa: this.idPa || null
        }

        if (this.isCooperado && this.cooperadoId) {
          payload.pessoaId = this.cooperadoId
        }

        await FilaAtendimentoRepository.Create(payload)

        if (this.stompClient && this.stompClient.connected) {
          const mensagem = {
            type: 'NOVO_ATENDIMENTO',
            payload: {
              categoriaId: this.selectedCategory ? this.selectedCategory.id : null
            }
          }

          this.stompClient.send('/app/atendimento/novo', {}, JSON.stringify(mensagem))
        }

        this.step = 6

        setTimeout(() => {
          this.voltarParaInicio()
        }, 10000)
      } catch (error) {
        console.error('Erro ao criar senha na fila de atendimento:', error)
        alert('Erro ao criar senha: ' + (error.message || JSON.stringify(error)))
      }
    },
    confirmCancel () {
      this.showConfirmModal = true
      this.resetInactivityTimer()
    },
    resetProcess () {
      this.step = 1
      this.userInput = ''
      this.category = ''
      this.selectedCategory = null
      this.selectedSubcategory = null
      this.selectedService = ''
      this.password = ''
      this.showConfirmModal = false
      this.isCooperado = false
      this.clearInactivityTimer()
    },
    voltarParaInicio () {
      this.step = 1
      this.userInput = ''
      this.password = ''
      this.nomeCooperado = ''
      this.cooperadoId = null
      this.selectedCategory = null
      this.selectedSubcategory = null
      this.selectedService = ''
      this.categoriaSelecionada = false
      this.subcategoriaSelecionada = false
      this.clearInactivityTimer()
    },
    resetInactivityTimer () {
      this.clearInactivityTimer()

      if (this.step !== 1 && this.step !== 6) {
        this.inactivityTimer = setTimeout(() => {
          this.resetProcess()
        }, 60000)
      }
    },
    clearInactivityTimer () {
      if (this.inactivityTimer) {
        clearTimeout(this.inactivityTimer)
        this.inactivityTimer = null
      }
    },
    connectWebSocket () {
      const socket = new SockJS(`${process.env.APIBaseBPM}/websocket`)
      this.stompClient = Stomp.over(socket)

      this.stompClient.connect({}, () => {
        console.log('WebSocket conectado!')

        if (this.userId) {
          this.stompClient.subscribe(`/topic/atendimento/novo/${this.userId}`, message => {
            // const data = JSON.parse(message.body)
          })
        }

        this.stompClient.subscribe('/topic/ultimos-chamados', message => {
          // const data = JSON.parse(message.body)
        })
      }, error => {
        console.error('Erro no WebSocket:', error)
        setTimeout(this.connectWebSocket, 5000)
      })
    }

  },
  watch: {
    step (newStep) {
      this.resetInactivityTimer()
      if (newStep === 4) {
        this.categoriaSelecionada = false
      }
      if (newStep === 5) {
        this.subcategoriaSelecionada = false
      }
    }
  }
}
</script>

<style scoped>
html, body {
  overflow: auto;
  height: auto;
  margin: 0;
  touch-action: none;
}

.container-fluid {
  height: 100vh;
}

.card {
  border-radius: 20px;
  box-shadow: 0 0 1em #ccc;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 700px;
  height: 50vh;
  margin-top: 0;
  padding: 5rem;
  text-align: center;
  width: 100%;
  overflow-y: auto;
  max-height: 60vh;
  transition: height 0.3s ease;
}

.card-step4 {
  height: auto !important;
  max-height: none !important;
  overflow-y: visible !important;
  justify-content: flex-start !important;
  padding-bottom: 3rem;
}

.custom-btn {
  width: 200px;
  padding: 15px;
  font-size: 18px;
  font-weight: bold;
  border-radius: 12px;
  border: 1px solid #ccc;
}

.etapa4-container {
  width: 100%;
  height: auto;
  overflow: visible;
}

.step4 {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.button-wrapper {
  width: 100%;
  max-width: 100%;
  padding: 0 1rem;
  display: flex;
  justify-content: center;
}

.button-step4 {
  margin-top: 10px;
  width: 100%;
  max-width: 400px;
  white-space: nowrap;
  text-align: center;
  padding: 15px;
  font-size: 1rem;
  border-radius: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/nxSenhas/totem/totem.vue